import React from "react"
import { useDispatch } from "react-redux"
import { disableSLO, enableSLO } from "reduxSlices/SAMLConfigurationsSlice"
import { SAMLConfigurationShape } from "utils/propTypeShapes"
import Switch from "shared/Switch"
import SAMLConfigurationsListItemSection from "./SAMLConfigurationsListItemSection"

const DISABLE_CONFIRMATION = "Are you sure you want to disable single logout?"
const ENABLE_CONFIRMATION = "Are you sure you want to enable single logout?"

const sloDescription = ({ hasSingleLogoutUrl, signUsersOutOfIdentityProvider }) => {
  if (signUsersOutOfIdentityProvider) {
    return (
      "Single logout is enabled.  Users signed out of our application are also signed out of the identity provider."
    )
  }

  if (hasSingleLogoutUrl) {
    return (
      "Single logout is disabled. Users signed out of our application will not be signed out of the identity provider."
    )
  }

  // SAML configuration does not have a single logout url
  return (
    "Single logout is not supported by the identity provider.  This SAML configuration "
    + "does not include a single logout URL.  Users signed out of our application "
    + "will not be signed out of the identity provider."
  )
}

const SAMLConfigurationListItemSLOSection = ({ configuration }) => {
  const dispatch = useDispatch()

  const { hasSingleLogoutUrl, id, signUsersOutOfIdentityProvider } = configuration

  const toggleSLO = () => {
    if (!hasSingleLogoutUrl) return

    const toggleAction = signUsersOutOfIdentityProvider ? disableSLO : enableSLO
    const confirmMessage = signUsersOutOfIdentityProvider ? DISABLE_CONFIRMATION : ENABLE_CONFIRMATION

    if (window.confirm(confirmMessage)) {
      dispatch(toggleAction({ id }))
    }
  }

  return (
    <SAMLConfigurationsListItemSection title="Single Logout">
      <div className="flex flex-col gap-8 sm:gap-4 w-full">
        <div className="flex flex-row space-between w-full">
          <span className="grow">Sign users out of identity provider</span>
          <Switch checked={signUsersOutOfIdentityProvider} disabled={!hasSingleLogoutUrl} onChange={toggleSLO} />
        </div>
        <p className="text-xs text-dark">{sloDescription({ hasSingleLogoutUrl, signUsersOutOfIdentityProvider })}</p>
      </div>
    </SAMLConfigurationsListItemSection>
  )
}

SAMLConfigurationListItemSLOSection.propTypes = {
  configuration: SAMLConfigurationShape.isRequired,
}

export default SAMLConfigurationListItemSLOSection
